import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "col-span-2" }
const _hoisted_2 = { class: "col-span-2" }

import { ref, toRef, computed } from "vue";
import {
  ContainerProperties,
  useStarsPositions,
} from "@/composables/useStarsPositions";


export default /*@__PURE__*/_defineComponent({
  __name: 'FlyingStarsComponent',
  props: {
    azimuthFacade: {},
    stars: {},
    color: {}
  },
  setup(__props: any) {

const props = __props;

const starsContainerRef = ref<HTMLElement | null>(null);

const getStarsContainerProps = computed<ContainerProperties | null>(() => {
  const newRect = starsContainerRef.value?.getBoundingClientRect() ?? null;
  if (!newRect) {
    return null;
  }
  const size = newRect.width; // т.к. aspect-square → width === height
  const halfSize = size / 2;
  const itemHalf = 24; // size-12 = 3rem = 48px → половина 24px

  return {
    centerX: halfSize,
    centerY: halfSize,
    radius: halfSize - itemHalf - 8, // запас 8px, чтобы не касались края
  };
});

const { starsPositions, starsContainerProperties, getStarIndex } =
  useStarsPositions(
    toRef(props, "azimuthFacade"),
    () => getStarsContainerProps.value
  );

function disableAppearTransition(el: HTMLElement) {
  el.style.transition = "none";
}

function enableAppearTransition(el: HTMLElement) {
  el.style.transition = "left 0.6s ease-out, top 0.6s ease-out";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "starsContainerRef",
    ref: starsContainerRef,
    class: "absolute top-1/2 left-1/2 z-[800] translate-x-[-50%] translate-y-[-50%] select-none h-1/2 aspect-square rounded-full",
    style: _normalizeStyle(`color: ${__props.color}`)
  }, [
    _createVNode(_TransitionGroup, {
      tag: "div",
      name: "star-pos",
      css: true,
      appear: "",
      onBeforeAppear: disableAppearTransition,
      onAfterAppear: enableAppearTransition
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(starsPositions), (starPosition, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "star-container",
            style: _normalizeStyle({
          left: starPosition.x + 'px',
          top: starPosition.y + 'px',
          transform: 'translate(-50%, -50%)',
          'border-color': __props.color,
        })
          }, [
            _createElementVNode("div", null, _toDisplayString(__props.stars[_unref(getStarIndex)(i)].sk), 1),
            _createElementVNode("div", null, _toDisplayString(__props.stars[_unref(getStarIndex)(i)].sf), 1),
            _createElementVNode("div", _hoisted_1, _toDisplayString(__props.stars[_unref(getStarIndex)(i)].sb), 1),
            _createElementVNode("div", null, _toDisplayString(__props.stars[_unref(getStarIndex)(i)].sy), 1),
            _createElementVNode("div", null, _toDisplayString(__props.stars[_unref(getStarIndex)(i)].sm), 1)
          ], 4))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: "star-container",
      style: _normalizeStyle({
        left: _unref(starsContainerProperties).centerX + 'px',
        top: _unref(starsContainerProperties).centerY + 'px',
        transform: 'translate(-50%, -50%)',
        'border-color': __props.color,
      })
    }, [
      _createElementVNode("div", null, _toDisplayString(__props.stars[9].sk), 1),
      _createElementVNode("div", null, _toDisplayString(__props.stars[9].sf), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.stars[9].sb), 1),
      _createElementVNode("div", null, _toDisplayString(__props.stars[9].sy), 1),
      _createElementVNode("div", null, _toDisplayString(__props.stars[9].sm), 1)
    ], 4)
  ], 4))
}
}

})